import { render, staticRenderFns } from "./tpl-3.vue?vue&type=template&id=c755908c&scoped=true"
import script from "./tpl-3.vue?vue&type=script&lang=js"
export * from "./tpl-3.vue?vue&type=script&lang=js"
import style0 from "./tpl-3.vue?vue&type=style&index=0&id=c755908c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c755908c",
  null
  
)

export default component.exports